// extracted by mini-css-extract-plugin
export default {"section":"Releases-module__section--unjIY","count":"Releases-module__count--fxMcg"};